exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".data-export .export-button {\n  margin-top: 15px;\n  width: 100%; }\n\n.modal-title {\n  text-align: center;\n  font-weight: 600;\n  color: #5d6368; }\n\n.modal-contents {\n  margin: 30px;\n  color: #5d6368; }\n  .modal-contents .report-options {\n    display: block;\n    height: 30px;\n    margin-bottom: 40px;\n    line-height: 13px; }\n    .modal-contents .report-options .title {\n      font-weight: 600;\n      font-size: 14px; }\n    .modal-contents .report-options .desc {\n      margin-left: 22px;\n      font-size: 12px;\n      color: #979b9f;\n      white-space: normal;\n      overflow-wrap: break-word; }\n  .modal-contents .search-select {\n    display: inline-block;\n    width: 160px;\n    margin-top: -20px;\n    margin-left: 10px; }\n    .modal-contents .search-select:first-of-type {\n      margin-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Analytics/components/DataExport/style.scss
// module id = 981
// module chunks = 0